export const defaultOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0,
};

// アニメーションの初期化
export const initializeObserveAnimation = (targets, options = {}) => {
  const targetsLength = targets.length;

  if (targetsLength === 0) {
    console.error("initializeObserveAnimation: 対象の要素が見つかりませんでした。");
    return;
  }

  const mergedOptions = { ...defaultOptions, ...options };
  const observer = createObserver(mergedOptions, targetsLength);
  targets.forEach((target) => observer.observe(target));
};

// IntersectionObserverの作成
export const createObserver = (options, targetsLength) => {
  let observer;
  let activeCount = 0;

  const handleObserve = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute("data-animated", "true");
        observer.unobserve(entry.target);
        activeCount++;
      }
    });

    if (activeCount === targetsLength) {
      observer.disconnect();
    }
  };

  observer = new IntersectionObserver(handleObserve, options);
  return observer;
};

// DOMContentLoadedイベントリスナー
document.addEventListener("DOMContentLoaded", () => {
  const targetElements = document.querySelectorAll("[data-scroll-animation]");

  const options = {
    rootMargin: "10% 0px",
    threshold: 0.5,
  };

  initializeObserveAnimation(targetElements, options);
});
